import React from "react";
import PropTypes from "prop-types";

// TODO: Implement icon. Should be simple, but is missing a CSS class to format the icon correctly.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    size?: "small" | "medium" | "large" | "full-width";
    outline?: boolean;
    //icon?: React.ReactNode;
    danger?: boolean;
    loading?: boolean;
    disabled?: boolean;
    target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"];
    href?: React.AnchorHTMLAttributes<HTMLAnchorElement>["href"];
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
    // Functions
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * It's a button. You click it!
 * 
 * ## _
 * ### Arguments
 * @param {string} size - One of "small", "medium", "large", or "full-width". Determines the size of the button.
 * @param {boolean} outline - A flag for making the button outlined instead of filled.
 * @param {boolean} danger - A flag for making the button show a warning color.
 * @param {boolean} loading - A flag for updating the button when something is loading.
 * @param {boolean} disabled - A flag for disabling the button.
 * @param {string} target - In the event of using a link-type button, this populates the target prop.
 * @param {string} href - In the event of using a link-type button, this populates the href prop.  
 * @param {React.ReactNode} children - The contents inside the button.
 * @param {string} className - CSS classes to apply to the button.
 * 
 * ## _
 * ### Functions
 * @param {function} onClick - Function called when the button is clicked.  
 */
class Button extends React.Component<ButtonProps> {
    static propTypes = {
        size: PropTypes.oneOf(["small", "medium", "large", "full-width"]),
        outline: PropTypes.bool,
        danger: PropTypes.bool,
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        target: PropTypes.string,
        href: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        size: "medium",
        className: "",
        danger: false,
        loading: false,
    };

    render() {
        const { size, outline, danger, loading, disabled, onClick, target, href, children, className, ...rest } = this.props;

        let classes = "a-button";
        classes += ` a-button--${size}`;

        if (danger) classes += " a-button--destructive";
        if (disabled) classes += " a-button--disabled";
        if (loading) classes += " a-button--loading";
        if (outline) classes += " a-button--outline";

        if (className) classes += ` ${className}`

        if (href) {
            return (
                <a className={classes} href={href} target={target}>
                    {children}
                </a>
            );
        }

        return (
            <button className={classes} onClick={onClick} disabled={disabled} {...rest}>
                {children}
            </button>
        );
    }
}

export default Button;